import { render, staticRenderFns } from "./CookieWarn.vue?vue&type=template&id=53ddcf4c"
import script from "./CookieWarn.vue?vue&type=script&lang=js"
export * from "./CookieWarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports